'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var infix = function infix(queryTerm) {
  return {
    evaluate: function evaluate() {
      var searchText = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];

      if (!searchText) {
        return false;
      }

      return searchText.indexOf(queryTerm) !== -1;
    },
    matches: function matches() {
      var searchText = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];

      if (!searchText) {
        return [];
      }

      var splitString = searchText.split(queryTerm);
      var result = [];
      var currentPosition = 0;

      for (var x = 0; x < splitString.length; x++) {
        result.push({
          startIndex: currentPosition + splitString[x].length,
          length: queryTerm.length
        });

        currentPosition += splitString[x].length + queryTerm.length;
      }

      result.pop();

      return result;
    }
  };
};

var prefix = function prefix(queryTerm) {
  return {
    evaluate: function evaluate() {
      var searchText = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];

      if (!searchText) {
        return false;
      }

      return searchText.indexOf(queryTerm) === 0;
    },
    matches: function matches() {
      var searchText = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];

      if (!searchText) {
        return [];
      }

      var prefixIndex = searchText.indexOf(queryTerm);

      if (prefixIndex === 0) {
        return [{
          startIndex: 0,
          length: queryTerm.length
        }];
      }

      return [];
    }
  };
};

exports.default = {
  infix: infix,
  prefix: prefix
};


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-search/dist/strategies.js
// module id = 220
// module chunks = 0